module.exports = __webpack_public_path__ + "img/premium3.f77c7e81.jpg";